var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskAstroOrionTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_7002_12575)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#9B7AF7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_7002_12575_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.37928e-10 -0.014 0.0138686 3.41582e-10 14 14)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1081.58,
    y: -1081.58,
    width: 2163.16,
    height: 2163.16
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(50, 68, 231, 1) 0deg,rgba(0, 1, 15, 0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.19680553674697876,\"g\":0.26795840263366699,\"b\":0.90833336114883423,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0062500089406967163,\"b\":0.06250,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":6.7585580154627678e-07,\"m01\":27.737213134765625,\"m02\":0.13139232993125916,\"m10\":-28.000001907348633,\"m11\":6.8316455781314289e-07,\"m12\":28.000001907348633},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7002_12575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1938 16.8064C9.08959 14.7022 6.52504 13.65 3.50019 13.65C6.52504 13.65 9.08959 12.5979 11.1938 10.4937C13.2981 8.38944 14.3502 5.8249 14.3502 2.80005C14.3502 5.8249 15.4023 8.38944 17.5066 10.4937C19.6108 12.5979 22.1753 13.6501 25.2002 13.6501C22.1753 13.6501 19.6108 14.7022 17.5066 16.8064C15.4023 18.9107 14.3502 21.4752 14.3502 24.5001C14.3502 21.4752 13.2981 18.9107 11.1938 16.8064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_7002_12575",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.245833 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7002_12575"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_7002_12575"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7002_12575",
    result: "effect2_innerShadow_7002_12575"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_7002_12575_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7002_12575",
    x: 2.5,
    y: 1.80005,
    width: 23.7002,
    height: 23.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7002_12575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskAstroOrionTheme);
export default __webpack_public_path__ + "static/media/AskAstroOrionTheme.144837a0b89af79f4cd591633e87252f.svg";
export { ForwardRef as ReactComponent };